import axios from 'axios'
import requesturl from '../requesturl'
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    async getAppRights(rights) {
        await axios.get(requesturl() + "/api/latest/AppRight", {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                rights(res.data);
                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async getPoolGroupRights(rights) {
        await axios.get(requesturl() + "/api/latest/PoolGroupRight", {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                rights(res.data);
                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async deleteAppRight(right, response) {
        await axios.delete(requesturl() + "/api/latest/AppRight/" + right.rightId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };
                response(responseObj);
            })
            .catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };

                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
                response(responseObj);
            });
    },

    async deletePoolGroupRight(right, response) {
        await axios.delete(requesturl() + "/api/latest/PoolGroupRight/" + right.rightId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };
                response(responseObj);
            })
            .catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
                response(responseObj);
            });
    },

    async postAppRight(right, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/AppRight',
            headers: headers,
            data: JSON.stringify(right)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
            response(responseObj);
        });
    },

    async postPoolGroupRight(right, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/PoolGroupRight',
            headers: headers,
            data: JSON.stringify(right)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
            response(responseObj);
        });
    },

    async putAppRight(right, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'put',
            url: requesturl() + '/api/latest/AppRight/' + right.rightId,
            headers: headers,
            data: JSON.stringify(right)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };
            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
            response(responseObj);
        });
    },

    async putPoolGroupRight(right, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'put',
            url: requesturl() + '/api/latest/PoolGroupRight/' + right.rightId,
            headers: headers,
            data: JSON.stringify(right)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };
            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            response(responseObj);
        });
    }
}



// WEBPACK FOOTER //
// ./src/interfaces/rightinterface.js